import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { OpcionRespuestaAdicionalEncuestaService } from "./opcion-respuesta-adicional-encuesta.service";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import { AuthService } from "src/app/shared/services/auth.service";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: "app-opcion-respuesta-adicional-encuesta",
  templateUrl: "./opcion-respuesta-adicional-encuesta.component.html",
  styleUrls: ["./opcion-respuesta-adicional-encuesta.component.scss"],
})
export class OpcionRespuestaAdicionalEncuestaComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerOpcionRespuestaAdicionalEncuesta: Array<string>;
  formOpcionRespuestaAdicionalEncuesta: FormGroup;
  selectOpcionRespuestaAdicionalEncuesta: any;

  paginaActual: number;
  // filtros
  filtro: FormGroup;
  public isCollapsed = true;

  // Selects
  moduloEncuestaByAnioFiltro: Array<any> = [];
  seccionEncuestaByModuloFiltro: Array<any> = [];
  preguntaAdicionalEncuestaBySeccionFiltro: Array<any> = [];
  camaraComercio: Array<any>;
  moduloEncuestaByAnio: Array<any> = [];
  seccionEncuestaByModulo: Array<any> = [];
  preguntaAdicionalEncuestaBySeccion: Array<any>;
  adminSuper = RolesUsuario.AdministradorSuper;

  constructor(
    private formBuilder: FormBuilder,
    private opcionRespuestaAdicionalEncuestaService: OpcionRespuestaAdicionalEncuestaService,
    private modalService: NgbModal,
    public authService: AuthService
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
    this.createForm();
    this.consultarListasFiltro();
    this.onConsultarOpcionRespuestaAdicionalEncuesta(1);
    this.selectOpcionRespuestaAdicionalEncuesta = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.headerOpcionRespuestaAdicionalEncuesta = [
      "Pregunta Adicional",
      "Cámara Comercio",
      "Respuesta",
      "Año",
      "Orden",
      "Requiere Respuesta Adicional",
      "Estado",
      "Acción",
    ];

    this.formOpcionRespuestaAdicionalEncuesta
      .get("anio")
      .valueChanges.pipe(debounceTime(500))
      .subscribe((x) => {
        if (x?.length) {
          this.opcionRespuestaAdicionalEncuestaService
            .getModuloEncuestaByAnio(x)
            .subscribe((resultado) => {
              if (resultado.data) {
                this.moduloEncuestaByAnio = resultado.data;
                this.seccionEncuestaByModulo = [];
                this.preguntaAdicionalEncuestaBySeccion = [];
              } else {
                this.moduloEncuestaByAnio = [];
              }
            });
        } else {
          this.moduloEncuestaByAnio = [];
          this.seccionEncuestaByModulo = [];
          this.preguntaAdicionalEncuestaBySeccion = [];
        }
        this.formOpcionRespuestaAdicionalEncuesta
          .get("modulo_encuesta_id")
          .patchValue(null);
        this.formOpcionRespuestaAdicionalEncuesta
          .get("seccion_encuesta_id")
          .patchValue(null);
        this.formOpcionRespuestaAdicionalEncuesta
          .get("pregunta_adicional_encuesta_id")
          .patchValue(null);
      });

    this.formOpcionRespuestaAdicionalEncuesta
      .get("modulo_encuesta_id")
      .valueChanges.subscribe((x) => {
        if (x) {
          this.opcionRespuestaAdicionalEncuestaService
            .getSeccionEncuestaByModulo(x)
            .subscribe((resultado) => {
              if (resultado.data) {
                this.seccionEncuestaByModulo = resultado.data;
                this.preguntaAdicionalEncuestaBySeccion = [];
              }
            });
        } else {
          this.seccionEncuestaByModulo = [];
          this.preguntaAdicionalEncuestaBySeccion = [];
        }
        this.formOpcionRespuestaAdicionalEncuesta
          .get("seccion_encuesta_id")
          .patchValue(null);
        this.formOpcionRespuestaAdicionalEncuesta
          .get("pregunta_adicional_encuesta_id")
          .patchValue(null);
      });

    this.formOpcionRespuestaAdicionalEncuesta
      .get("seccion_encuesta_id")
      .valueChanges.subscribe((x) => {
        if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
          this.formOpcionRespuestaAdicionalEncuesta
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
        }
        if (
          this.formOpcionRespuestaAdicionalEncuesta.value.codigo_camara &&
          x
        ) {
          this.opcionRespuestaAdicionalEncuestaService
            .getPreguntaAdicionalEncuestaBySeccion(
              this.formOpcionRespuestaAdicionalEncuesta.value.codigo_camara,
              x
            )
            .subscribe((resultado) => {
              if (resultado.data) {
                this.preguntaAdicionalEncuestaBySeccion = resultado.data;
              }
            });
        } else {
          this.preguntaAdicionalEncuestaBySeccion = [];
        }
        this.formOpcionRespuestaAdicionalEncuesta
          .get("pregunta_adicional_encuesta_id")
          .patchValue(null);
      });

    this.formOpcionRespuestaAdicionalEncuesta
      .get("codigo_camara")
      .valueChanges.subscribe((x) => {
        if (
          this.formOpcionRespuestaAdicionalEncuesta.value.seccion_encuesta_id &&
          x
        ) {
          this.opcionRespuestaAdicionalEncuestaService
            .getPreguntaAdicionalEncuestaBySeccion(
              x,
              this.formOpcionRespuestaAdicionalEncuesta.value
                .seccion_encuesta_id
            )
            .subscribe((resultado) => {
              if (resultado.data) {
                this.preguntaAdicionalEncuestaBySeccion = resultado.data;
              }
            });
        } else {
          this.preguntaAdicionalEncuestaBySeccion = [];
        }
        this.formOpcionRespuestaAdicionalEncuesta
          .get("pregunta_adicional_encuesta_id")
          .patchValue(null);
      });
  }

  createForm() {
    this.formOpcionRespuestaAdicionalEncuesta = this.formBuilder.group({
      modulo_encuesta_id: [null, Validators.required],
      seccion_encuesta_id: [null, Validators.required],
      pregunta_adicional_encuesta_id: [null, Validators.required],
      requiere_respuesta_adicional: [null, Validators.required],
      descripcion: [null, Validators.required],
      codigo_camara: [null, Validators.required],
      anio: [null, Validators.required],
      orden: [null, Validators.required],
      activo: [true],
    });

    this.filtro = this.formBuilder.group({
      modulo_encuesta_id: [null],
      seccion_encuesta_id: [null],
      pregunta_adicional_encuesta_id: [null],
      requiere_respuesta_adicional: [null],
      codigo_camara: [null],
      descripcion: [null],
      anio: [null],
      orden: [null],
      activo: [null],
    });
  }

  onConsultarOpcionRespuestaAdicionalEncuesta(page: number) {
    this.opcionRespuestaAdicionalEncuestaService
      .get({
        ...this.filtro.value,
        numeroPagina: page,
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC)
          ? this.authService.getCamaraUser()
          : this.filtro.value.codigo_camara,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarOpcionRespuestaAdicionalEncuesta(value);
  }

  onAgregarOpcionRespuestaAdicionalEncuesta() {
    this.opcionRespuestaAdicionalEncuestaService
      .create({
        ...this.formOpcionRespuestaAdicionalEncuesta.value,
        activo: 1,
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC)
          ? this.authService.getCamaraUser()
          : this.formOpcionRespuestaAdicionalEncuesta.value.codigo_camara,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarOpcionRespuestaAdicionalEncuesta(this.paginaActual);
          this.formOpcionRespuestaAdicionalEncuesta.reset();
        }
      });
  }

  onOperarOpcionRespuestaAdicionalEncuesta() {
    if (!this.selectOpcionRespuestaAdicionalEncuesta) {
      this.onAgregarOpcionRespuestaAdicionalEncuesta();
    } else {
      this.onModificarOpcionRespuestaAdicionalEncuesta();
    }
  }

  onCargarOpcionRespuestaAdicionalEncuesta(entry: any) {
    entry.activo = entry.activo ? 1 : 0;
    entry.requiere_respuesta_adicional = entry.requiere_respuesta_adicional
      ? 1
      : 0;
    this.formOpcionRespuestaAdicionalEncuesta.patchValue(
      {
        ...entry,
      },
      { emitEvent: false }
    );

    if (entry.anio) {
      this.opcionRespuestaAdicionalEncuestaService
        .getModuloEncuestaByAnio(entry.anio)
        .subscribe((resultado) => {
          if (resultado.data) {
            this.moduloEncuestaByAnio = resultado.data;
          }
        });
    }

    if (entry.modulo_encuesta_id) {
      this.opcionRespuestaAdicionalEncuestaService
        .getSeccionEncuestaByModulo(entry.modulo_encuesta_id)
        .subscribe((resultado) => {
          if (resultado.data) {
            this.seccionEncuestaByModulo = resultado.data;
          }
        });
    }

    if (entry.seccion_encuesta_id && entry.codigo_camara) {
      this.opcionRespuestaAdicionalEncuestaService
        .getPreguntaAdicionalEncuestaBySeccion(
          entry.codigo_camara,
          entry.seccion_encuesta_id
        )
        .subscribe((resultado) => {
          if (resultado.data) {
            this.preguntaAdicionalEncuestaBySeccion = resultado.data;
          }
        });
    }

    this.selectOpcionRespuestaAdicionalEncuesta = entry;
  }

  onEliminarOpcionRespuestaAdicionalEncuesta(entry: any) {
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, {
      centered: true,
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this.opcionRespuestaAdicionalEncuestaService
        .delete(entry)
        .subscribe((resultado) => {
          if (resultado.result) {
            // tslint:disable-next-line:max-line-length
            const index = this.dataTabla.items
              .map(function (e) {
                return e.opcion_respuesta_adicional_id;
              })
              .indexOf(entry.opcion_respuesta_adicional_id);
            this.dataTabla.items.splice(index, 1);
            this.selectOpcionRespuestaAdicionalEncuesta = null;
            this.formOpcionRespuestaAdicionalEncuesta.reset();
          }
        });
    });
  }

  onModificarOpcionRespuestaAdicionalEncuesta() {
    this.selectOpcionRespuestaAdicionalEncuesta.opcion_respuesta_adicional_id;

    this.opcionRespuestaAdicionalEncuestaService
      .update({
        ...this.formOpcionRespuestaAdicionalEncuesta.value,
        opcion_respuesta_adicional_id: this
          .selectOpcionRespuestaAdicionalEncuesta.opcion_respuesta_adicional_id,
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC)
          ? this.authService.getCamaraUser()
          : this.formOpcionRespuestaAdicionalEncuesta.value.codigo_camara,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarOpcionRespuestaAdicionalEncuesta(this.paginaActual);
          this.formOpcionRespuestaAdicionalEncuesta.reset();
          this.selectOpcionRespuestaAdicionalEncuesta = null;
        }
      });
  }

  consultarListasFiltro() {
    this.opcionRespuestaAdicionalEncuestaService
      .getCamaraComercio()
      .subscribe((resultado) => {
        if (resultado.data) {
          this.camaraComercio = resultado.data;
        }
        if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
          this.formOpcionRespuestaAdicionalEncuesta
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
        }
      });
    this.filtro
      .get("anio")
      .valueChanges.pipe(debounceTime(500))
      .subscribe((x) => {
        if (x?.length) {
          this.opcionRespuestaAdicionalEncuestaService
            .getModuloEncuestaByAnio(x)
            .subscribe((resultado) => {
              if (resultado.data) {
                this.moduloEncuestaByAnioFiltro = resultado.data;
                this.seccionEncuestaByModuloFiltro = [];
                this.preguntaAdicionalEncuestaBySeccionFiltro = [];
              }
            });
        } else {
          this.moduloEncuestaByAnioFiltro = [];
          this.seccionEncuestaByModuloFiltro = [];
          this.preguntaAdicionalEncuestaBySeccionFiltro = [];
        }
        this.filtro.get("modulo_encuesta_id").patchValue(null);
        this.filtro.get("seccion_encuesta_id").patchValue(null);
        this.filtro.get("pregunta_adicional_encuesta_id").patchValue(null);
      });

    this.filtro.get("modulo_encuesta_id").valueChanges.subscribe((x) => {
      if (x?.length) {
        this.opcionRespuestaAdicionalEncuestaService
          .getSeccionEncuestaByModulo(x)
          .subscribe((resultado) => {
            if (resultado.data) {
              this.seccionEncuestaByModuloFiltro = resultado.data;
              this.preguntaAdicionalEncuestaBySeccionFiltro = [];
            }
          });
      } else {
        this.seccionEncuestaByModuloFiltro = [];
        this.preguntaAdicionalEncuestaBySeccionFiltro = [];
      }
      this.filtro.get("seccion_encuesta_id").patchValue(null);
      this.filtro.get("pregunta_adicional_encuesta_id").patchValue(null);
    });

    this.filtro.get("seccion_encuesta_id").valueChanges.subscribe((x) => {
      if (this.filtro.value.codigo_camara?.length && x?.length) {
        this.opcionRespuestaAdicionalEncuestaService
          .getPreguntaAdicionalEncuestaBySeccion(
            this.filtro.value.codigo_camara,
            x
          )
          .subscribe((resultado) => {
            if (resultado.data) {
              this.preguntaAdicionalEncuestaBySeccionFiltro = resultado.data;
            }
          });
      } else {
        this.preguntaAdicionalEncuestaBySeccionFiltro = [];
      }
      this.filtro.get("pregunta_adicional_encuesta_id").patchValue(null);
    });

    this.filtro.get("codigo_camara").valueChanges.subscribe((x) => {
      if (this.filtro.value.seccion_encuesta_id?.length && x?.length) {
        this.opcionRespuestaAdicionalEncuestaService
          .getPreguntaAdicionalEncuestaBySeccion(
            x,
            this.filtro.value.seccion_encuesta_id
          )
          .subscribe((resultado) => {
            if (resultado.data) {
              this.preguntaAdicionalEncuestaBySeccionFiltro = resultado.data;
            }
          });
      } else {
        this.preguntaAdicionalEncuestaBySeccionFiltro = [];
      }
      this.filtro.get("pregunta_adicional_encuesta_id").patchValue(null);
    });
  }

  filtrar() {
    this.paginaActual = 1;
    this.onConsultarOpcionRespuestaAdicionalEncuesta(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }
  limpiarOpcionEncuesta() {
    this.formOpcionRespuestaAdicionalEncuesta.reset();
    this.selectOpcionRespuestaAdicionalEncuesta = null;
    // this.createForm();
    if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
      this.formOpcionRespuestaAdicionalEncuesta
        .get("codigo_camara")
        .patchValue(this.authService.getCamaraUser());
    }
  }
}
